module.exports = __webpack_public_path__ + "img/whiteontransparent.b150356b.png";